<div class="page-tab-bar hidden-xs hidden-sm flex-container">
  <a
    *ngFor="let subPage of subPages"
    [routerLink]="subPage.routerLink"
    routerLinkActive="active"
    class="page-tab-bar__btn"
    >{{ subPage.routerLink }}</a
  >
</div>
